import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DriverHitchCalendarComponent } from './calendar/driver-hitch-calendar.component';
import {DriverInformationComponent} from './driver-information/driver-information.component';
import {NavBarComponent} from './nav-bar/nav-bar.component';
import {NewsFeedComponent} from './news-feed/news-feed.component';
import {OwnerDashboardComponent} from './owner-dashboard/owner-dashboard.component';

const routes: Routes = [
  {
    path: '',
    component: NavBarComponent,
    children: [
      {
        path: 'owner-dashboard',
        component: OwnerDashboardComponent,
      },
      {
        path: 'calendar',
        component: DriverHitchCalendarComponent,
      },
      {
        path: 'driver-information',
        component: DriverInformationComponent
      },
      {
        path: 'news-feed',
        component: NewsFeedComponent
      },
      {
        redirectTo: 'owner-dashboard',
        path: '',
        pathMatch: 'full'
      }
    ],
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OwnerDashboardRoutingModule {}
